import { forwardRef } from 'react';
import { css } from '@emotion/react';

import { BaseInput } from '../BaseInput';
import type { BaseInputProps } from '../BaseInput';

export type NumberInputProps = Omit<
  BaseInputProps,
  'actionContent' | 'customContent' | 'showInvalidIcon' | 'type' | 'ref'
>;

const numberInputStyles = css`
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

/**
 * A number input allows users to enter or edit numeric values.
 *
 * {@link https://zeroheight.com/76c439891/v/latest/p/7668be-number-input/b/445389 Usage guidelines}
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-numberinput--basic-number-input Code documentation}
 *
 * @example
 * <NumberInput defaultValue="123" />
 */
export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  (props: NumberInputProps, ref): JSX.Element => {
    return (
      <BaseInput
        {...props}
        type="number"
        ref={ref}
        inputStyles={[numberInputStyles, props.inputStyles]}
      />
    );
  },
);

NumberInput.displayName = 'NumberInput';

NumberInput.defaultProps = {
  isDisabled: false,
  isInvalid: false,
  isRequired: false,
  isReadonly: false,
  size: 'm',
};
